// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/So_ProductFiscalResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/product_fiscal/get/{product_id}
 *
 * `fiscal` is null when neither a franchise-specific nor a global fiscal
 * row exists for the product at all (not even registered, empty or not).
 */
import type { So_ProductFiscalEffectiveRow } from './So_ProductFiscalEffectiveRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type So_ProductFiscalResponseDados = So_ProductFiscalEffectiveRow;

export type So_ProductFiscalResponse = ApiResponse<So_ProductFiscalResponseDados>;

registerResponseContract('So_ProductFiscalResponse', {
  _nullable:                            { type: 'boolean', required: false },
  so_product_id:                        { type: 'number',  required: true },
  franchise_id:                         { type: 'number',  required: false },
  is_override:                          { type: 'boolean', required: true },
  is_configured:                        { type: 'boolean', required: true },
  so_product_fiscal_ncm:                { type: 'string',  required: false },
  so_product_fiscal_cest:               { type: 'string',  required: false },
  so_product_fiscal_cfop_dentro_uf:     { type: 'string',  required: false },
  so_product_fiscal_cfop_fora_uf:       { type: 'string',  required: false },
  so_product_fiscal_cst:                { type: 'string',  required: false },
  so_product_fiscal_csosn:              { type: 'string',  required: false },
  so_product_fiscal_origem:             { type: 'number',  required: false },
  so_product_fiscal_unidade_tributavel: { type: 'string',  required: false },
})
